module.exports = __webpack_public_path__ + "img/PGHOUSE.221ab504.jpeg";